export const ErrorLevelConfig = {
  SAGA: {
    FETCH_ERROR: 'Lỗi hệ thống, vui lòng liên hệ với VN-ITHelpdesk',
  },
};
